import { Props_SnippetContentColumn } from './ContentColumn.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContentColumn = (props: Props_SnippetContentColumn) => {
    const { heading, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? 'snippet-content-column__heading--visible' : 'snippet-content-column__heading--hidden'

    return (
        <section className="snippet-content-column">
            <div className={`snippet-content-column__container`}>
                <h2 className={`snippet-content-column__heading ${classHeadingVisibility}`}>{heading.content.value}</h2>
                <div className="snippet-content-column__container-entries">
                    {repeatable_entry.map(({ image, alt, heading, content, linkHref, linkStyle, linkText, linkTarget, linkAriaLabel }, index: number) => (
                        <div key={index} className={`snippet-content-column__entry`}>
                            {image?.value && (
                                <figure className="snippet-content-column__entry-image-container">
                                    <img
                                        className="snippet-content-column__entry-image"
                                        loading="lazy"
                                        height={190}
                                        width={350}
                                        src={image.value}
                                        alt={alt?.value ? alt.value : ''}
                                    />
                                </figure>
                            )}
                            <div className="snippet-content-column__entry-content-container">
                                {heading?.value && (
                                    <>
                                        <h3 className="snippet-content-column__entry-title">{heading.value}</h3>
                                        <hr className="snippet-content-column__entry-divider" />
                                    </>
                                )}
                                {content?.value && <div className="snippet-content-column__entry-content">{CompileMarkdown(content.value)}</div>}
                                <SnippetLink
                                    linkStyles={linkStyle?.value}
                                    className="snippet-content-column__entry-link"
                                    url={linkHref?.value}
                                    openInNewTab={linkTarget?.value}
                                    aria-label={linkAriaLabel?.value || linkText?.value}
                                >
                                    {linkText?.value}
                                </SnippetLink>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetContentColumn